module.exports = __webpack_public_path__ + "static/media/map_white.e9d9b534.svg";